export { images };

const images = [
  {
    alt: "Gîte Marée Haute",
    src: "./assets/imgCarousel/pictureHome.webp",
    title: "Gîte Marée Haute - Parenthèse Oceaner.com",
  },
  {
    alt: "Plage Clémenceau",
    src: "./assets/imgCarousel/pictureHome1.webp",
    title: "Plage Clémenceau - Parenthèse Oceaner.com",
  },
  {
    alt: "Plage rocheuse avec vagues déferlantes et ciel nuageux",
    src: "./assets/imgCarousel/pictureHome2.webp",
    title: "Plage rocheuse avec vagues - Parenthèse Oceaner.com",
  },
  {
    alt: "Champ verdoyant en premier plan, avec vue sur un ciel nuageux et une mer agitée en arrière-plan",
    src: "./assets/imgCarousel/pictureHome3.webp",
    title: "Champ verdoyant avec vue sur mer - Parenthèse Oceaner.com",
  },
  {
    alt: "Aire de jeux pour enfants avec trampoline et toboggan près du gîte",
    src: "./assets/imgCarousel/pictureHome9.webp",
    title: "Aire de jeux enfants près du gîte - Parenthèse Oceaner.com",
  },
 
{
    alt: "Vue sur la plage de la Vendée avec la maison de Clémenceau en arrière-plan et des arbres au bord de l'eau",
    src: "./assets/imgCarousel/pictureHome11.webp",
    title: "Plage de la Vendée et maison de Clémenceau - Parenthèse Oceaner.com" 
},

  {
    alt: "Commode blanche de chevet avec lampe allumée",
    src: "./assets/imgCarousel/pictureHome5.webp",
    title: "Commode blanche de chevet - Parenthèse Oceaner.com",
  },
 {
    alt: "Un vélo avec un escabeau près d'un arbre",
    src: "./assets/imgCarousel/pictureHome10.webp",
    title: "Un vélo avec un escabeau près d'un arbre - Parenthèse Oceaner.com",
  },

  {
    alt: "Joli arbre solitaire au milieu d'un champ verdoyant",
    src: "./assets/imgCarousel/pictureHome6.webp",
    title: "Joli arbre solitaire - Parenthèse Oceaner.com",
  },
  {
    alt: "Joli puits en pierre avec de l'eau claire",
    src: "./assets/imgCarousel/pictureHome7.webp",
    title: "Joli puits en pierre - Parenthèse Oceaner.com",
  },
  {
    alt: "Femme et enfant regardant la mer",
    src: "./assets/imgCarousel/pictureHome8.webp",
    title: "Femme et enfant regardant la mer - Parenthèse Oceaner.com",
  },
];

export default images;
